export default __webpack_public_path__ + "static/media/contract.d412313f.svg";